import Sentry from "@similarweb/sentry-logger";

import { ONBOARDING_AGENT_NUDGE_COOLDOWN_MS } from "../../OnboardingAgent/constants";
import { ONBOARDING_AGENT_LOG_PREFIX } from "../../onboardingAgentConstants";

const ONBOARDING_AGENT_NUDGE_STORAGE_KEY = "onboardingAgentNudgeLastShownAtV1";

/** Fallback when localStorage read/write fails within the current page load. */
let lastShownAtInCurrentRuntime: number | null = null;

const logStorageError = (operation: "read" | "write", error: unknown): void => {
    Sentry.error(
        `${ONBOARDING_AGENT_LOG_PREFIX} Failed to ${operation} value in localStorage ` +
            `(key: "${ONBOARDING_AGENT_NUDGE_STORAGE_KEY}"):`,
        error as Error,
    );
};

const readStoredLastShownAt = (): number | null => {
    try {
        const stored = window.localStorage.getItem(ONBOARDING_AGENT_NUDGE_STORAGE_KEY);

        if (!stored) {
            return null;
        }

        const parsed = Number(stored);

        return Number.isFinite(parsed) ? parsed : null;
    } catch (error) {
        logStorageError("read", error);

        return null;
    }
};

export const hasNudgeBeenShownRecently = (): boolean => {
    const stored = readStoredLastShownAt();

    if (stored !== null && (lastShownAtInCurrentRuntime === null || stored > lastShownAtInCurrentRuntime)) {
        lastShownAtInCurrentRuntime = stored;
    }

    if (lastShownAtInCurrentRuntime === null) {
        return false;
    }

    return Date.now() - lastShownAtInCurrentRuntime < ONBOARDING_AGENT_NUDGE_COOLDOWN_MS;
};

export const markNudgeShown = (): void => {
    const now = Date.now();
    lastShownAtInCurrentRuntime = now;

    try {
        window.localStorage.setItem(ONBOARDING_AGENT_NUDGE_STORAGE_KEY, String(now));
    } catch (error) {
        logStorageError("write", error);
    }
};

/** @internal Clears in-memory cooldown state between unit tests. */
export const resetNudgeCooldownStateForTests = (): void => {
    lastShownAtInCurrentRuntime = null;
};
